import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { segmentsService } from '../segments.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedService } from '../../../shared/shared.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Logger } from 'angular2-logger/core';
import { Router } from '@angular/router';

// import * as $ from 'jquery';
//Jquery
declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-segments-list',
  templateUrl: './segments-list.component.html',
  styleUrls: ['./segments-list.component.scss']
})
export class segmentsListComponent implements OnInit, AfterViewInit {
  public total_items: number;
  public pag_size: number;
  public pag_number: number;
  public list: any;
  public itemQuantity = [];
  public on_button = false;
  public del_status: string;
  public text_delete: any;

  @ViewChild('contacts_pag') contacts_pag: ElementRef;
  @ViewChild('contacts_num') contacts_num: ElementRef;

  constructor(
    private _segmentsService: segmentsService,
    private spinner: NgxSpinnerService,
    private _sharedService: SharedService,
    public toastr: ToastsManager,
    private _router: Router,
    private logger: Logger
  ) { 
    this.pag_size = 10;
    this.pag_number = 1;
  }

  ngAfterViewInit() {
    $(this.contacts_pag.nativeElement).on('change', (e) => {
      this.pag_size = e.target.value;
      this.pag_number = 1;
      /* this.updatePage(); */
    });

    $(this.contacts_num.nativeElement).on('change', (e) => {
      this.pag_number = e.target.value;
     /*  this.updatePage(); */
    });
  }

  ngOnInit() {
/*     this.updatePage();
    $('#newLabelModal').modal('toggle', { backdrop: false });
    $('#newLabelModal').appendTo("body"); */
  }

  /* updatePage() {
      this.spinner.show();

      let data = {
        auth_token: this._sharedService.getCookie("auth_token"),
        limit: this.pag_size, // quantity of items
        page: this.pag_number  // page
      };

      this._segmentsService.getlistSegments(data).subscribe(
        data => {
          //this.load = false;
          this.spinner.hide();
          console.log(data);
          if (data.status) { //success
            this.list = data.data.data; //data list
            this.total_items = data.data.total;
            this.itemQuantity = Array(data.data.last_page).fill(0).map((x, i) => i + 1);
          } else { // API error
            this.toastr.error(data.message, 'Error');
          }

        },
        error => { //server error
          //this.load = false;
          this.spinner.hide();
          this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
          this.logger.log(error);
        }
      );
  }

 */



}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/segments/segments-list/segments-list.component.ts